import {useState, useEffect} from 'react';

/**
 * Returns a debounced copy of the provided value that only updates once the
 * input has been stable for `delay` milliseconds. Used by the SymbolPicker to
 * throttle search requests while the user is still typing.
 */
export function useDebounce<T>(value: T, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
